//
// Helper method for trackEvent, trackLink modules/methods
//
export function getExperimentPropertiesForEventPayload() {
    const experimentProperties = {};
    const experiments = window.experiments || {};

    Object.keys(experiments).forEach((key) => {
      if (key.match(/^experiment_/)) {
        experimentProperties[key] = experiments[key]
      }
    });

    return experimentProperties;
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/lib/platform/getExperimentPropertiesForEventPayload.js